import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';
import { BorderRadius, Colors, Spacing } from 'web-common/src/shared/styles';
import { FontWeight } from 'web-common/src/shared/styles/font';

const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: ${Spacing.HALF} ${Spacing.SINGLE};
  border-radius: ${BorderRadius.M};
  width: max-content;

  color: ${Colors.WHITE};
  font-weight: ${FontWeight.SEMI_BOLD};
  background-color: ${Colors.BELL_PEPPER};
  transition: background-color 0.11s ease-in-out;

  &:hover {
    background-color: ${Colors.RADISH_DARK_10};
  }
`;

interface IProps {
  link: string;
  text: string;
  className?: string;
  includeArrow?: boolean;
  onClick?: () => void;
}

export const Button: React.FC<IProps> = ({ link, text, includeArrow = true, className, onClick }) => {
  return (
    <Link href={link} className={className}>
      <StyledButton onClick={onClick}>
        <span>{text}</span>
        {includeArrow ? <i className='fas fa-chevron-right ml-3 text-sm' /> : null}
      </StyledButton>
    </Link>
  );
};
